export default __webpack_public_path__ + "static/Waste-Management-Solution-f9a5e076406445036dd927871cea6890.webp";